import { settings } from '../../../settings/settings-util';
import {initializeAlmeApi} from '../../../util/alme-api';

// define window.console for older IE browsers
// runs automatically because it has to run before any other webpack functions
(function setConsoleCompatibility() {
	if (!(window.console && window.console.log)) 
	{
		window.console = 
		{
			log: function() {},
			debug: function() {},
			info: function() {},
			warn: function() {},
			error: function() {}
		};
	}
})();

export function getDefaultSettings() {
	return settings;
}

// returns the base url of the javascript include so it can be used as the Alme base path
export function getHostName(launchScriptId) 
{
	let scriptTag = document.getElementById(launchScriptId);
	let url = scriptTag.getAttribute('src');

    if (url.indexOf('./') === 0)
    	return location.host;
    else
    	return url.substr(0, url.toLowerCase().lastIndexOf('/alme/')).replace("http://","").replace("https://","");
}

// injects the root alme container as a child of 'body'
export function injectAgentContainer(agentContainerId, passedSettings)
{
	initializeAlmeApi();
	
	let selectedSettings = passedSettings || settings;

    let agentDiv = document.createElement('div');
	agentDiv.id = agentContainerId || selectedSettings.Window.rootId;
	
	var accessibility = selectedSettings.accessibility || {};
    var labelledBy = accessibility.labelledBy || {};
	var elementName = labelledBy.root || "alme--window--header--banner";
	agentDiv.setAttribute('style', "display:none");
	agentDiv.setAttribute('dir', normalizeDirAttribute())

	var roles = accessibility.role || {};
	var role = roles.rootElement || "dialog";

	//return a promise incase we need to wait till the DIV is loaded
    return new Promise((resolve, reject) => {
        injectInternal(agentDiv, resolve);
    });
}

function injectInternal(agentDiv, resolve)
{
	let handleReady = () => {
		//inject element if there is not already one on page
		if (!document.getElementById(agentDiv.id))
			document.getElementsByTagName('body')[0].appendChild(agentDiv);
			//AWJ-137 Make the agent visible after the other elements have been so the page does not scroll to the bottom of the page
			agentDiv.style.display = "";
		resolve();
	}

	if (document.readyState === 'complete') {
		handleReady();
	} else {
		document.addEventListener('readystatechange', event => {
			if (document.readyState === 'complete')
				handleReady();
		});
	}
}

function normalizeDirAttribute(){
	let currentDirection = "ltr"
	
	let siteDir = document.documentElement.dir;

	if(siteDir !== ""){
		currentDirection = siteDir;
	}

	return currentDirection;
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/utilities-preload/src/utilities-preload.js